import { HttpHandler } from 'msw'

import { getAllDiagnostics } from './getAllDiagnostics'

export const diagnostics: HttpHandler[] = [getAllDiagnostics]
